import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, Table, Col, Row, Input, Button } from 'antd'

import { tableColumns } from '../../dataTypes/messages'
import { requestMessagesList, requestMessageDelete } from '../../redux/Messages/actions'

class Messages extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userFilter: '',
            roomFilter: '',
            stopSorting: true,
        }
        this.handleChangeRoom = this.handleChangeRoom.bind(this)
        this.handleChangeUser = this.handleChangeUser.bind(this)

        this.currentSorter = {}
    }

    componentDidMount() {
        const { requestMessagesList } = this.props

        requestMessagesList()
    }

    searchMessage = () => {
        const { requestMessagesList } = this.props

        requestMessagesList(1, this.state.userFilter, this.state.roomFilter, this.currentSorter.field)
    }

    handleChangeUser(event) {
        this.setState({ userFilter: event.target.value })
    }

    handleChangeRoom(event) {
        this.setState({ roomFilter: event.target.value })
    }

    handleDelete = messageId => {
        const { requestMessageDelete } = this.props

        requestMessageDelete({ messageId, roomFilter: this.state.roomFilter, userFilter: this.state.userFilter })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { requestMessagesList } = this.props
        this.setState({ stopSorting: !sorter.field })
        this.currentSorter = sorter
        requestMessagesList(pagination.current, this.state.userFilter, this.state.roomFilter, sorter.field)
    }

    render() {
        const {
            messagesList,
            pagination: { page_size, page_number, total_entries },
            loading,
        } = this.props
        const { stopSorting } = this.state

        return (
            <Card title="Messages Table">
                <div>
                    <Row type="flex">
                        <Col lg={8} sm={9} xs={24}>
                            <Input
                                placeholder="Channel ID"
                                onChange={this.handleChangeRoom}
                                value={this.state.roomFilter}
                                onPressEnter={this.searchMessage}
                            />
                        </Col>
                        <Col lg={8} sm={9} xs={24}>
                            <Input
                                placeholder="User ID or username"
                                onChange={this.handleChangeUser}
                                value={this.state.userFilter}
                                onPressEnter={this.searchMessage}
                            />
                        </Col>
                        <Col lg={4} sm={6} xs={12}>
                            <Button type="primary" onClick={this.searchMessage}>
                                Search
                            </Button>
                        </Col>
                    </Row>
                </div>
                <Table
                    className="gx-table-responsive"
                    columns={tableColumns({
                        handleDelete: this.handleDelete,
                        stopSorting,
                    })}
                    dataSource={messagesList}
                    bordered
                    rowKey={record => record.id}
                    pagination={{
                        pageSize: page_size,
                        current: page_number,
                        total: total_entries
                    }}
                    onChange={this.handleTableChange}
                    loading={loading}
                />
            </Card>
        )
    }
}

const mapStateToProps = state => ({
    messagesList: state.messages.list,
    pagination: state.messages.pagination,
    loading: state.messages.loading,
})

const mapActionsToProps = dispatch => ({
    requestMessagesList: bindActionCreators(requestMessagesList, dispatch),
    requestMessageDelete: bindActionCreators(requestMessageDelete, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(Messages)
